"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var formatName = function formatName(_ref) {
  var firstName = _ref.firstName,
    lastName = _ref.lastName,
    title = _ref.title;
  var nameArr = [];
  if (title) nameArr.push(title);
  if (firstName) nameArr.push(firstName);
  if (lastName) nameArr.push(lastName);
  return nameArr.join(" ");
};
var _default = formatName;
exports.default = _default;